

const checkMiddlewares = async (router, store) => {
    router.beforeResolve(async (to, from, next) => {
        try {
            const { middlewares } = to.matched[0].props.default
            if (!middlewares) { setTemplate(to, store); next() }
            for (const index in middlewares) {
                if (!await middlewares[index](to, from, next)) break
                if ((parseInt(index) + 1) == middlewares.length) {
                    setTemplate(to, store)
                    next()
                }
            }
        } catch (e) {
            setTemplate(to, store)
            next()
        }
    })
}

let setTemplate = async (to, store) => {
    try {
        store.state.template = to.matched[0].props.default.template
    } catch (e) {
        store.state.template = 'default'
    }
}

export default {
    install: async (Vue, router, store) => {
    // setTemplate(router, store)
        checkMiddlewares(router, store)
    },
}
